import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SelfTruncatingPathComponent } from '@portal-core/general/components/self-truncating-path/self-truncating-path.component';
import { LifeCycleModule } from '@portal-core/general/directives/life-cycle/life-cycle.module';

@NgModule({
  declarations: [SelfTruncatingPathComponent
  ],
  imports: [
    CommonModule,
    LifeCycleModule,
    MatTooltipModule
  ],
  exports: [
    SelfTruncatingPathComponent
  ]
})
export class SelfTruncatingPathModule { }
